export function formatCurrency(x, decimalCount) {
  return Number.parseFloat(x).toFixed(decimalCount).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}
export function formatCurrencyWithSign(value, decimalCount = 2) {
  if (Number.parseFloat(value) < 0) {
    return `-$${formatCurrency(Math.abs(value), decimalCount)}`;
  }
  return `$${formatCurrency(value, decimalCount)}`;
}
